import React from 'react';
import { useTranslation } from 'react-i18next';

const PaginationControls = ({ currentPage, pageSize, totalRecords, onPageChange, onPageSizeChange }) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startRecord = currentPage * pageSize + 1;
  const endRecord = Math.min((currentPage + 1) * pageSize, totalRecords);
  const isFirstPage = currentPage === 0;
  const isLastPage = currentPage === totalPages - 1;

  return (
    <div className="pagination-controls">
      <div className="pagination-info">
        {t('messageDownload.recordsRange', { start: startRecord, end: endRecord, total: totalRecords })}
      </div>
      
      <div className="pagination-container">
        <div className="pagination-control-group">
          <label className="pagination-label">{t('messageDownload.rowsPerPage')}:</label>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(parseInt(e.target.value))}
            className="pagination-select"
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="250">250</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
        
        <div className="pagination-control-group">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={isFirstPage}
            className="pagination-button"
          >
            ← {t('common.previous')}
          </button>
          
          <div className="pagination-control-group">
            <label className="pagination-label">{t('messageDownload.page')}:</label>
            <select
              value={currentPage}
              onChange={(e) => onPageChange(parseInt(e.target.value))}
              className="pagination-select"
            >
              {Array.from({ length: totalPages }, (_, i) => (
                <option key={i} value={i}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>
          
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={isLastPage}
            className="pagination-button"
          >
            {t('common.next')} →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;